export default __webpack_public_path__ + "static/media/regulatory--weight-limit-with-trucks--g1.c0fc507e.png";